import { useEffect, memo } from 'react'

// ** MUI Imports
import IconButton from '@mui/material/IconButton'

// ** Icon Imports
import Icon from '../../../components/icon'

import { useSettings } from 'components/hooks/useSettings'

const ModeToggler = memo(() => {
  // ** Props
  const { settings, saveSettings } = useSettings()

  const handleModeChange = mode => {
    saveSettings({ ...settings, mode: mode })
  }

  const handleModeToggle = () => {
    handleModeChange(settings.mode === 'light' ? 'dark' : 'light')
  }

  return (
    <IconButton color='inherit' aria-haspopup='true' onClick={handleModeToggle}>
      <Icon fontSize='1.625rem' icon={settings.mode === 'dark' ? 'tabler:sun' : 'tabler:moon-stars'} />
    </IconButton>
  )
});

ModeToggler.displayName = 'ModeToggler';
export default ModeToggler;
